import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AnnouncementInterface } from 'src/app/models/interface/announcement.interface';

export const announcementsState = createFeatureSelector('announcements');
export const getAnnouncements = createSelector(announcementsState, announcements => announcements);
export const getAnnouncementsByLatest = createSelector(announcementsState, (announcements: Array<AnnouncementInterface>) =>
  announcements.sort((a, b) => parseInt(b.id.toString(), 10) - parseInt(a.id.toString(), 10))
);
